module.exports = __webpack_public_path__ + "img/Group_1.8dce8663.png";